import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Container,
  IconButton,
  SvgIcon,
  Theme,
  alpha,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useMobileNav } from "hooks/use-mobile-nav";
import { useEffect, useState } from "react";
import TopNavSection from "./TopNavSection";

const TOP_NAV_HEIGHT = 64;
const SIDE_NAV_WIDTH = 280;

interface CustomProps {
  onMobileNavOpen: () => void;
  sections?: any;
}

const TopNav = (props: CustomProps) => {
  const muiTheme = useTheme();
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const mobileNav = useMobileNav();
  const [bgColor, setBgColor] = useState("transparent");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setBgColor(
          muiTheme.palette.mode === "dark"
            ? "rgba(27, 27, 27, 0.9)"
            : alpha(muiTheme.palette.background.paper, 0.95)
        );
      } else {
        setBgColor("transparent");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [muiTheme.palette.mode, muiTheme.palette.background.paper]);

  return (
    <Box
      component="header"
      sx={{
        height: bgColor !== "transparent" ? "60px" : "100px",
        width: "100%",
        backgroundColor: bgColor,
        position: "fixed",
        top: 0,
        backdropFilter: bgColor !== "transparent" ? "blur(8px)" : "blur(0px)",
        zIndex: (theme) => theme.zIndex.appBar,
        boxShadow:
          bgColor !== "transparent"
            ? muiTheme.palette.mode === "dark"
              ? "0px 4px 12px rgba(0, 0, 0, 0.3)"
              : "0px 4px 12px rgba(0, 0, 0, 0.1)"
            : "none",
        transition: "all 0.3s ease",
        // borderBottom:
        //   bgColor !== "transparent"
        //     ? `1px solid ${muiTheme.palette.divider}`
        //     : "none",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <TopNavSection />
        {!mdUp && (
          <IconButton
            onClick={props.onMobileNavOpen}
            sx={{
              color: "text.primary",
              ml: "auto",
            }}
          >
            <SvgIcon>
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        )}
      </Container>
    </Box>
  );
};

export default TopNav;
